import { defineComponent as _defineComponent } from 'vue'
import NewAvailabilitySwitchSection from '@/components/toolbar/NewAvailabilitySwitchSection.vue';
import { ref, watch } from 'vue';
import NewAvailabilityDateSelect from '@/components/toolbar/NewAvailabilityDateSelect.vue';
import NewAvailabilityHoursSelect from '@/components/toolbar/NewAvailabilityHoursSelect.vue';
import useAvailabilityState from '@/state/availabilityState';
import { watchDebounced, watchImmediate } from '@vueuse/core';
import AvailabilityService from '@/services/AvailabilityService';


export default /*#__PURE__*/_defineComponent({
  __name: 'NewAvailabilityPanel',
  setup(__props) {

const { availability } = useAvailabilityState();

const isNot = ref(!availability.value?.available);
const isPartly = ref(!(availability.value?.availableFulltime ?? false));
const isLater = ref(!(availability.value?.availableNow ?? false));

watchImmediate(isNot, (is) => {
  if (is) {
    isPartly.value = false;
    isLater.value = false;
  }
});

watch([isNot, isPartly, isLater], ([isNot, isPartly, isLater]) => {
  if (!availability.value) return;
  availability.value = {
    ...availability.value,
    available: !isNot,
    availableFulltime: !isPartly,
    availableNow: !isLater,
  };
});

const setHoursPerWeek = (hours: number) => {
  if (!availability.value) return;
  availability.value = {
    ...availability.value,
    availableHoursPerWeek: hours
  };
};

const setDates = (dates: { from: string; to: string }) => {
  if (!availability.value) return;
  availability.value = {
    ...availability.value,
    availableFrom: dates.from,
    availableTo: dates.to,
  };
};

watchDebounced(availability, async (newAvailability) => {
  if (!newAvailability) return;
  const {
    available, availableFulltime, availableFrom, availableTo, availableHoursPerWeek, availableNow,
  } = newAvailability;
  await AvailabilityService.saveAvailability(
    available,
    availableNow,
    availableFulltime,
    availableFrom,
    availableTo,
    availableHoursPerWeek,
  );
}, { debounce: 500 });


return { __sfc: true,availability, isNot, isPartly, isLater, setHoursPerWeek, setDates, NewAvailabilitySwitchSection, NewAvailabilityDateSelect, NewAvailabilityHoursSelect }
}

})